export default __webpack_public_path__ + "static/media/ico-copier_coller.e3514b39.svg";